import type { DateString } from './dateString';
import type { CabinClass } from '@web-platform/shared-universal-constants/src/cabinClass';
import type { TripType } from '@web-platform/shared-universal-constants/src/tripTypes';
import type { Values } from '@web-platform/shared-universal-types-utils/src/utils';

export const NOTIFICATION_SAVED = 'NOTIFICATION_SAVED';
export const NOTIFICATION_ERROR = 'NOTIFICATION_ERROR';
export const NOTIFICATION_RESET = 'NOTIFICATION_RESET';
export const UPDATE_ACTION_ID = 'UPDATE_ACTION_ID';
export const UPDATE_DIALOG_TEXT = 'UPDATE_DIALOG_TEXT';
export const NOTIFICATION_REMOVED = 'NOTIFICATION_REMOVED';
export const DEFERRED_STATUS_TEXT = 'DEFERRED_STATUS_TEXT';
// Notification sources
export const NOTIFICATION_SOURCE = {
  // Banana sources
  COMBINED_RESULTS: 'COMBINED_RESULTS',
  BOOKING_PANEL: 'BOOKING_PANEL',
  // Acorn sources
  DAY_VIEW: 'day_view',
  BOOKING_PANEL_ACORN: 'booking_panel',
} as const;

export type S2LNotificationSource = Values<typeof NOTIFICATION_SOURCE>;

export type SearchLeg = {
  originEntityId: string;
  destinationEntityId: string;
  date: DateString;
};

export type FlightItinerarySearchVariables = {
  adults: number;
  nonAdultAges: number[];
  cabinClass: CabinClass;
  currency: string;
  market: string;
  locale: string;
  searchLegs: SearchLeg[];
  fareAttributes?: string[];
  tripType: TripType;
  nearbyAlternatives: {
    origin: boolean;
    destination: boolean;
  };
};
